import { Link } from "react-router-dom";
import { CONTACT } from "../data/content";

export const Footer = () => {
  return (
    <footer className="no-print mt-20 border-t border-[var(--border)]">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-5 py-10 sm:px-8 md:flex-row md:items-center md:justify-between">
        <div>
          <p className="font-head text-base font-bold">Matt Kolar</p>
          <p className="mt-1 text-sm text-[var(--text-2)]">Built with Emergent for this conversation</p>
        </div>
        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
          <Link to="/" className="text-[var(--text-2)] transition-colors hover:text-[var(--text)]" data-testid="footer-nav-interview">
            Interview
          </Link>
          <Link to="/work" className="text-[var(--text-2)] transition-colors hover:text-[var(--text)]" data-testid="footer-nav-work">
            More work
          </Link>
          <Link to="/resume" className="text-[var(--text-2)] transition-colors hover:text-[var(--text)]" data-testid="footer-nav-resume">
            Résumé
          </Link>
          <a
            href={CONTACT.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[var(--text-2)] transition-colors hover:text-[var(--text)]"
            data-testid="footer-linkedin-link"
          >
            LinkedIn
          </a>
        </nav>
      </div>
    </footer>
  );
};
